// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","content":"App_content__wwONY"};